import { useMemo } from 'react';

import { useZoomAssignedGroupsQuery } from 'core/graphql';

export interface IZoomGroupOption {
  value: string;
  label: string;
}

/**
 * Option list for the shared group filter (Recordings / Lessons): every group
 * that has a Zoom account bound. One cache-first request is shared across the
 * Zoom pages so the dropdown is stable and identical everywhere.
 */
export const useZoomGroupOptions = (): IZoomGroupOption[] => {
  const { data } = useZoomAssignedGroupsQuery({
    variables: { first: 200 },
    fetchPolicy: 'cache-first',
  });

  return useMemo(
    () =>
      (data?.allGroups?.edges ?? [])
        .map((edge) => edge?.node)
        .filter((node): node is NonNullable<typeof node> => Boolean(node))
        .map((node) => ({ value: node.id, label: node.name })),
    [data],
  );
};
